import React from 'react';
import styled from 'styled-components';

const TextWrapper = styled.div`
  margin-top: 1rem;
`;

const InfoText = () => {
  return (
    <TextWrapper>
      To respond to this query, a two-step process must be completed on this
      page:
      <br />
      &emsp;1. Read through the list of requirements above and assess whether
      you can offer a product that satisfies all requirements. Confirm that your
      product meets each requirement by ticking the associated boxes. All boxes
      need to be ticked to be able to respond to this query.
      <br />
      &emsp; 2. Add a valid URL to your company website or, ideally, a product
      page. For better visibility and ranking, feel free to write any notes, and
      attach product image(s), data or other material that better describe your
      product.
      {/* To respond to
      this query, a two-step validation must be completed:
      1:Read through the criteria list and decide if you can offer a
      product that satisfies all the requirements.
      2: You will need to tick all the boxes to be able to respond.
      <br />
      &emsp;3: Add a valid URL to your company website or a product page. <br />
      For better visibility and ranking, feel free to write any notes, and
      attach product image(s) or other material that better describe your
      product. */}
    </TextWrapper>
  );
};

export default InfoText;
